import Resource from '@/api/core/resource'
import appConfig from '@/config/appConfig'
class Interfaz extends Resource {
  constructor () {
    super('tesoreria/interfaces')
  }

  procesarComprobantes () {
    return this.request.get(this.uri.concat('/procesar-comprobantes'))
  }
  procesarProyectoPago (proyectoPagoId) {
    return this.request.get(
      this.uri
        .concat('/procesar-proyecto-pago/')
        .concat(proyectoPagoId)

    )
  }

  descargar (interfazId) {
    window.open(
      appConfig.urlServer.concat(
        this.uri
          .concat('/')
          .concat(interfazId)
          .concat('/descargar')
      )
    )
  }
}

export default new Interfaz()
